<template>
  <div class="rtl">
    <user-tabs></user-tabs>
    <m-form
      title="اپراتور ها"
      :apiUrl="baseUrl"
      :cols="cols"
      :isEditing.sync="isEditing"
      :canDelete="false"
      :canSubmit="true"
      :show-navigation-btns="false"
      :showListBtn="false"
      :showListExportBtn="false"
      :list_filters="filters"
      @click:row="setItem"
      @clearForm="clearForm"
      @submit="submit"
      @delete="deleteItem"
      ref="form"
    >
      <template #default>
        <v-row>
          <v-col cols="12" md="6">
            <v-text-field label=" * نام" v-model="item.first_name" :disabled="!isEditing" class="rounded-lg" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="* نام خانوادگی" v-model="item.last_name" :disabled="!isEditing" class="rounded-lg" />
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label=" * نام کاربری" v-model="item.username" :disabled="!isEditing" class="rounded-lg" />
          </v-col>
          <v-col cols="12">
                <v-switch
                  inset
                  color="success"
                  class="mr-md-3 mt-3 mt-md-1"
                  label="فعال" v-model="item.is_active" :disabled="!isEditing" />
          </v-col>
          <template v-if="!item.id && isEditing">
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field label="* کلمه عبور" v-model="item.password" :disabled="!isEditing" class="rounded-lg" />
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                label="* تکرار کلمه عبور"
                v-model="item.password_repeat"
                :disabled="!isEditing"
                class="rounded-lg"
              />
            </v-col>
          </template>

          <template>
            <v-col cols="12">
              <v-divider></v-divider>
            </v-col>
            <v-col cols="12" md="12">دسترسی ها</v-col>
            <v-col cols="12" md="12">
              <v-checkbox label="صفحه اصلی" v-model="permissions.home_page" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="کاربران" v-model="permissions.users" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="کد تخفیف" v-model="permissions.discounts" :disabled="!isEditing"></v-checkbox>

              <v-checkbox label="شرکت ها" v-model="permissions.companies" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="اپراتور ها" v-model="permissions.operators" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="فاکتور ها" v-model="permissions.factors" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="تراکنش ها" v-model="permissions.transactions" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="کد های معرف" v-model="permissions.referral_codes" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="افزونه ها" v-model="permissions.extensions" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="ایجاد و ویرایش پکیج کاربران" v-model="permissions.can_activate_packages " :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="ویرایش و تغییر قیمت بسته ها" v-model="permissions.can_edit_packages " :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="مشاهده حسابداری ابری" v-model="permissions.cloud_accounting" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="مدیریت برداشت ها" v-model="permissions.can_manage_withdrawals" :disabled="!isEditing"></v-checkbox>
              <v-checkbox label="مودیان" v-model="permissions.moadian_submissions" :disabled="!isEditing"></v-checkbox>
            </v-col>
          </template>
        </v-row>
      </template>
      <template #footer-btns>
        <v-btn
          :disabled="!isEditing"
          v-if="item.id"
          @click="showChangePasswordDialog = true"
          class="info rounded-lg white--text mr-1"
          depressed
        >
          تغیر کلمه عبور
        </v-btn>
      </template>
    </m-form>

    <v-dialog v-model="showChangePasswordDialog" max-width="500px">
      <v-card>
        <v-card-title>تغیر کلمه عبور</v-card-title>
        <v-card-text>
          <v-text-field label="کلمه عبور جدید" v-model="newPassword" />
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn @click="changePassword" class="w-100px green white--text">ثبت</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import MFormMixin from "@/components/m-form/MForm.js";
import UserTabs from "@/views/panel/UserTabs";

export default {
  components: { UserTabs },
  mixins: [MFormMixin],
  props: {},
  data() {
    return {
      baseUrl: "sobhanAdmin/operators/",
      appendSlash: true,
      serverProcessing: true,
      items: [],
      newPassword: "",
      showChangePasswordDialog: false,
      permissions: {},
      cols: [
        {
          text: "نام",
          value: "first_name",
          type: "text",
          filters: ["first_name"],
        },
        {
          text: "نام خانوادگی",
          value: "last_name",
          type: "text",
          filters: ["last_name"],
        },
        {
          text: "نام کاربری",
          value: "username",
          type: "text",
          filters: ["username"],
        },
      ],
      filters: {},
    };
  },
  computed: {},
  created() {
    this.item = this.getItemTemplate();
  },
  methods: {
    setItem(item) {
      this.permissions = { ...item.admin_permissions };
      this.item = { ...item };
      delete this.item.admin_permissions;
    },
    getItemTemplate() {
      return {
        is_active: true
      };
    },
    getPermissionsTemplate() {
      return {
        users: false,
        discounts: false,
      };
    },
    getSerialized() {
      let serialized = {
        user: this.item,
        permissions: this.permissions,
      };

      return serialized;
    },
    changePassword() {
      this.request({
        url: this.endpoint(`sobhanAdmin/changePassword`),
        method: "post",
        data: {
          user: this.item.id,
          password: this.newPassword,
        },
        success: (data) => {
          this.newPassword = "";
          this.successNotify();
          this.showChangePasswordDialog = false;
        },
      });
    },
  },
};
</script>
